import RedirectToAlohomora from "./RedirectToAlohomora";
import { getAppBasePath } from "../../main/utils";
import RedirectToBookshelf from "./RedirectToBookshelf";
import React from "react";
import { useBrand } from "../providers/brand/brand-context";
import { useLocation } from "react-router-dom";

export default function RedirectToLogin({
  finalizeLogout,
}: {
  finalizeLogout?: boolean;
}) {
  const brand = useBrand();
  const location = useLocation();

  if (brand.getProp("Alohomora.enabled")) {
    return <RedirectToAlohomora finalizeLogout={finalizeLogout} />;
  } else {
    // fall back to fraction user pages
    const returnTo = encodeURIComponent(
      `${getAppBasePath()}${location.pathname}${location.search}`
    );

    return (
      <RedirectToBookshelf path={`/user/check?userCheckReturnTo=${returnTo}`} />
    );
  }
}
